/* tslint:disable:indent */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ElementRef
} from '@angular/core';
import {ChoixFormulaireMessages} from 'src/app/modules/shared/models/component-messages/choix-formulaire-messages';
import {StepperBuilderService} from '../../services/stepper.builder.service';
import {TypeOrganisme} from '../../../../../models/TypeOrganise';
import {TypeMarche} from '../../../../../models/TypeMarche';
import {MontantMarche} from '../../../../../models/montant-marche';
import {TypeAvis} from '../../../../../models/TypeAvis';
import * as jsonColsChoixForm from '../../../../../../assets/dynamic/choixForm/tableCols.json';
import {FormItem} from '../../models/form.item';
import {TableContent} from '../../../../shared/generic/components/tableau/model/table.content';
import {FormControl, FormGroup} from '@angular/forms';
import {FormExtractorService} from '../../../../shared/services/form-extractor.service';
import {DefaultFormulaireCritere} from './model/default.formulaire.critere';
import {BehaviorSubject} from 'rxjs';
import {Endpoints} from '../../../../../models/endpoints';
import {LogService} from '../../../../shared/services/log.service';
import {ToastrService} from 'ngx-toastr';
import {ToasterMessage} from '../../../../shared/models/component-messages/toastr/toastr-message';
import {CanNavigateInStepperService} from '../../../../shared/services/can-navigate-in-stepper.service';
import {TranslateService} from '@ngx-translate/core';
import {HttpService} from '../../../../shared/services/http.service';
import {Avis} from '../../../../../models/avis';
import {Flux} from '../../../../../models/flux';
import {AvisService} from "../../../services/avis-service";
import { SpinnerVisibilityService } from 'ng-http-loader';
import { AccessibleToastComponent } from '../../../../../components/toast/accessible-toast.component';
import { environment } from '../../../../../../environments/environment';


@Component({
  selector: 'app-stepper-choix-formulaire',
  templateUrl: './choix-formulaire.component.html',
  styleUrls: ['./choix-formulaire.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChoixFormulaireComponent implements OnInit, OnDestroy {
  @ViewChild('selectField') selectField!: ElementRef;
  private LOG: LogService = new LogService(ChoixFormulaireComponent);
  private defaultCritere: DefaultFormulaireCritere;

  @Input() public defaultCritereBhs: BehaviorSubject<DefaultFormulaireCritere> = new BehaviorSubject(null);
  @Input() public currentFormOnUpdate: BehaviorSubject<String> = new BehaviorSubject(null);
  @Input() public currentJson: BehaviorSubject<any>;
  @Input() form: FormGroup;

  public tableContent: TableContent;
  public choixFormulaire = new ChoixFormulaireMessages();
  public listTypeOrga: TypeOrganisme[];
  public listTypeMarche: TypeMarche[];
  public listTypeAvis: TypeAvis[];
  public listTypeMontant: MontantMarche[];
  public formList: FormItem[] = [];
  isUpdate = false;
  isChoixFormulaire = false;
  public references: any[] = [];
  avisRefSelected: boolean = false;
  public sortingColumn = {name: 'typedavis', start: 'desc'};

  public toasterMessage = new ToasterMessage();

  constructor(private stepperBuilderService: StepperBuilderService, private http: HttpService,
              private formExtractorService: FormExtractorService, private cd: ChangeDetectorRef,
              private toastr: ToastrService, private canNavigateInStepperService: CanNavigateInStepperService,
              private translateService: TranslateService,
              private avisService: AvisService,
              private spinner: SpinnerVisibilityService
  ) {

  }

  ngOnDestroy(): void {
    this.canNavigateInStepperService.isChoixFormulaire = false;
    this.canNavigateInStepperService.linkableNotices = [];
  }

  public ngOnInit() {
    this.canNavigateInStepperService.isChoixFormulaire = true;
    if (this.isReliable()) {
      this.references = this.canNavigateInStepperService.linkableNotices;
    }
    var referenceParent = this.canNavigateInStepperService.getReferenceParent();
    if (referenceParent) {
      this.canNavigateInStepperService.selectedDiffuseurInitial = referenceParent.flux.map(f => f.id.diffuseurId);
      this.canNavigateInStepperService.diffReference.emit(referenceParent.flux.map(f => f.id.diffuseurId));
      this.currentJson.next(referenceParent.reference);
    }

    this.isChoixFormulaire = true;
    this.tableContent = new TableContent();
    this.tableContent.displayedCols = ['radio', 'intitule', 'typedavis', 'directive', 'action'];
    this.tableContent.uniqueKey = 'intitule';
    this.tableContent.tableCols = jsonColsChoixForm.table;


    this.defaultCritere = new DefaultFormulaireCritere();
    this.form.addControl('typeOrganisme', new FormControl({value: this.defaultCritere.organismeCode}));
    this.form.addControl('typeMarche', new FormControl({value: this.defaultCritere.marcheCode}));
    this.form.addControl('montantMarche', new FormControl({value: this.defaultCritere.montantCode}));
    this.form.addControl('typeAvis', new FormControl({value: this.defaultCritere.avisCode}));
    this.form.addControl('formIntitule', new FormControl({value: ''}));

    this.defaultCritereBhs.subscribe(data => {
      if (data) {
        this.isUpdate = true;
        this.defaultCritere = data;
        // dans le cas d'une modification
        this.form.get('typeOrganisme').setValue(this.defaultCritere.organismeCode);
        this.form.get('typeMarche').setValue(this.defaultCritere.marcheCode);
        this.form.get('montantMarche').setValue(this.defaultCritere.montantCode);
        this.form.get('typeAvis').setValue(this.defaultCritere.avisCode);
        this.form.controls.typeOrganisme.disable();

        const typeOrganisme = new TypeOrganisme();
        typeOrganisme.code = this.defaultCritere.organismeCode;
        typeOrganisme.libelle = this.defaultCritere.organismeLibelle;
        this.listTypeOrga = [];
        this.listTypeOrga.push(typeOrganisme);

        // init typeMarche
        const typeMarche = new TypeMarche();
        typeMarche.code = this.defaultCritere.marcheCode;
        typeMarche.libelle = this.defaultCritere.marcheLibelle;
        this.listTypeMarche = [];
        this.listTypeMarche.push(typeMarche);

        const montant = new MontantMarche();
        montant.code = this.defaultCritere.montantCode;
        montant.libelle = this.defaultCritere.montantLibelle;
        this.listTypeMontant = [];
        this.listTypeMontant.push(montant);

        const typeAvis = new TypeAvis();
        typeAvis.code = this.defaultCritere.avisCode;
        typeAvis.libelle = this.defaultCritere.avisLibelle;
        this.listTypeAvis = [];
        this.listTypeAvis.push(typeAvis);

        this.cd.detectChanges();

      } else {
        this.getAllForms();
        this.getTypeOrganismeEndPoint();
        this.form.get('typeOrganisme').setValue(this.defaultCritere.organismeCode);
        this.form.get('typeMarche').setValue(this.defaultCritere.marcheCode);
        this.form.get('montantMarche').setValue(this.defaultCritere.montantCode);
        this.form.get('typeAvis').setValue(this.defaultCritere.avisCode);
        this.cd.detectChanges();
      }
    });

    this.currentFormOnUpdate.subscribe(data => {
      if (data) {
        this.isUpdate = true;
        const formItem: FormItem = new FormItem();
        const dataItem = data as any;
        formItem.intitule = dataItem.intitule;
        formItem.directive = dataItem.directiveAssociee;
        formItem.enum = dataItem.code;
        formItem.description = dataItem.noticeInformation;
        formItem.url = dataItem.urlNoticeInformation;
        formItem.norme = dataItem.typeNorme;
        this.formList = [];
        this.formList.push(formItem);
        this.tableContent.tableData.next(this.formList);
        this.cd.detectChanges();
      }
    });
    this.spinner.hide();
  }

  /* private getOneForm(data){
     this.http.get(Endpoints.FIND_BY_FORMNAME + '?formName=' + data)
     .subscribe((data) => {
     });
   }*/

  private getTypeOrganismeEndPoint() {
    if (this.canNavigateInStepperService.getReferenceParent()) {
      return
    }
    return this.http.get(Endpoints.FIND_BY_ORGANISME).subscribe((data) => {
      this.listTypeOrga = Object.keys(data).map(index => {
        const typeOrganisme: TypeOrganisme = data[index];
        return typeOrganisme;
      });
      this.cd.detectChanges();
    });
  }

  public getActionEvent(event) {
    this.stepperBuilderService.formulaire = this.formList[this.formList.indexOf(event.data)].enum as any;
    this.form.get('formIntitule').setValue(this.formList[this.formList.indexOf(event.data)].intitule);
    this.canNavigateInStepperService.currentNormeFormulaire = this.formList[this.formList.indexOf(event.data)].norme;
    if (this.canNavigateInStepperService.compatibilite) {
      this.canNavigateInStepperService.compatibilite();
    }
  }

  /**
   * 1
   */
  public actualiseMarche() {
    this.listTypeMarche = [];
    this.listTypeMontant = [];
    this.listTypeAvis = [];
    this.form.get('typeMarche').setValue(undefined);
    this.http.get(Endpoints.FIND_BY_TYPE_MARCHE +
      Endpoints.FORMULAIRE_PARAM1 + this.getTypeOrganisme()
    ).subscribe((data) => {
      this.listTypeMarche = Object.keys(data).map(index => {
        const typeMarche: TypeMarche = data[index];
        return typeMarche;
      });
      this.cd.detectChanges();
    });
  }

  /**
   * 2
   */
  public actualiseMontant() {
    this.listTypeMontant = [];
    this.listTypeAvis = [];
    this.form.get('montantMarche').setValue(undefined);
    this.http.get(Endpoints.FIND_BY_MONTANT_MARCHE +
      Endpoints.FORMULAIRE_PARAM1 + this.getTypeOrganisme() +
      Endpoints.FORMULAIRE_PARAM2 + this.getTypeMarche()).subscribe((data) => {
      this.listTypeMontant = Object.keys(data).map(index => {
        const montantMarche: MontantMarche = data[index];
        return montantMarche;
      });
      this.cd.detectChanges();
    });
  }

  /**
   * 3
   */
  public actualiseAvis() {
    this.listTypeAvis = [];
    this.form.get('typeAvis').setValue(undefined);
    this.http.get(Endpoints.FIND_BY_TYPE_AVIS +
      Endpoints.FORMULAIRE_PARAM1 + this.getTypeOrganisme() +
      Endpoints.FORMULAIRE_PARAM2 + this.getTypeMarche() +
      Endpoints.FORMULAIRE_PARAM3 + this.getMontantMarche()).subscribe((data) => {
      this.listTypeAvis = Object.keys(data).map(index => {
        const typeAvis: TypeAvis = data[index];
        return typeAvis;
      });
      this.cd.detectChanges();
    });
  }

  public resetFields() {
    this.listTypeOrga = [];
    this.listTypeMontant = [];
    this.listTypeMarche = [];
    this.listTypeAvis = [];
    this.form.controls.typeOrganisme.setValue(undefined);
    this.form.controls.montantMarche.setValue(undefined);
    this.form.controls.typeMarche.setValue(undefined);
    this.form.controls.typeAvis.setValue(undefined);
    this.isUpdate = false;
    this.getTypeOrganismeEndPoint();
    this.getAllForms();
    this.selectField.nativeElement.focus();
  }


  public getAllForms() {
    this.http.get(Endpoints.ALL_FORMS).subscribe((data) => {
      this.formList = Object.keys(data).map(index => {
        if ((this.canNavigateInStepperService.getReferenceParent() && this.canNavigateInStepperService.linkableForms && !this.canNavigateInStepperService.linkableForms.includes(data[index].code)) || (environment.form_ad_enabled === "false" && data[index].code === "FORM_AD"))
          return;
        const formItem: FormItem = new FormItem();
        formItem.intitule = data[index].intitule;
        formItem.directive = data[index].directiveAssociee;
        formItem.typedavis = data[index].typeAvis;
        formItem.enum = data[index].code;
        formItem.description = data[index].noticeInformation;
        formItem.url = data[index].urlNoticeInformation;
        formItem.norme = data[index].typeNorme;
        return formItem;
      }).filter(data => data);
      this.canNavigateInStepperService.linkableForms = null;
      this.tableContent.tableData.next(this.formList);
      this.cd.detectChanges();
    });
  }

  public getForms() {
    this.http.get(Endpoints.FIND +
      Endpoints.FORMULAIRE_PARAM1 + this.getTypeOrganisme() +
      Endpoints.FORMULAIRE_PARAM2 + this.getTypeMarche() +
      Endpoints.FORMULAIRE_PARAM3 + this.getMontantMarche() +
      Endpoints.FORMULAIRE_PARAM4 + this.getTypeAvis()).subscribe(data => {
      this.formList = Object.keys(data).map(index => {
        if (environment.form_ad_enabled === "false" && data[index].code === "FORM_AD")
          return;
        const formItem: FormItem = new FormItem();
        formItem.intitule = data[index].intitule;
        formItem.directive = data[index].directiveAssociee;
        formItem.typedavis = data[index].typeAvis;
        formItem.enum = data[index].code;
        formItem.description = data[index].noticeInformation;
        formItem.url = data[index].urlNoticeInformation;
        formItem.norme = data[index].typeNorme;
        return formItem;
      }).filter(data => data);
      /*this.formList.forEach(form => {
        this.http.get(Endpoints.FIND_TYPEAVIS +
          Endpoints.TYPEAVIS_PARAM1 + form.enum).subscribe(data => {
            if (data){
              form.typedavis = data as string;
            }
          });
      });*/
      this.tableContent.tableData.next(this.formList);
      this.displayToast();
      this.cd.detectChanges();
    });
  }

  public displayToast() {
    const title = this.toasterMessage.titleInformation;
    let message = this.toasterMessage.M07;

    const montantMarche = this.formExtractorService.getMapControlsIdWithoutStepAndValue(this.form).get('montantMarche');
    const typeMarche = this.formExtractorService.getMapControlsIdWithoutStepAndValue(this.form).get('typeMarche');
    const typeOrganisme = this.formExtractorService.getMapControlsIdWithoutStepAndValue(this.form).get('typeOrganisme');

    if (montantMarche === 'C3_0') {
      message = this.toasterMessage.M04;
    } else if (
      (montantMarche === 'C3_1' && ['C2_1', 'C2_2', 'C2_4'].indexOf(typeMarche) !== -1) ||
      (montantMarche === 'C3_4' && typeMarche === 'C2_3')
    ) {
      message = this.toasterMessage.M05;
    } else if (
      (montantMarche === 'C3_2' && ['C2_1', 'C2_2'].indexOf(typeMarche) !== -1 && typeOrganisme === 'C1_2') ||
      (montantMarche === 'C3_2' && ['C2_1', 'C2_2'].indexOf(typeMarche) !== -1 && typeOrganisme === 'C1_1') ||
      (montantMarche === 'C3_10' && ['C2_1', 'C2_2'].indexOf(typeMarche) !== -1 && typeOrganisme === 'C1_5') ||
      (montantMarche === 'C3_6' && typeMarche === 'C2_4')
    ) {
      message = this.toasterMessage.M06;
    } else if (
      typeMarche === 'C2_3' && montantMarche === 'C3_5'
    ) {
      message = this.toasterMessage.M08;
    } else if (montantMarche === 'C3_8' && ['C2_1', 'C2_2'].indexOf(typeMarche) !== -1) {
      message = null;
    }

    if (message !== null) {
      this.toastr.show(this.translateService.instant(message), this.translateService.instant(title), {
        positionClass: 'toast-top-right',
        timeOut: 10000,
        toastComponent: AccessibleToastComponent
      }, 'info');
    }
  }

  public isButtonDisabled() {
    return !(this.getTypeOrganisme() !== undefined &&
      this.getMontantMarche() !== undefined &&
      this.getTypeMarche() !== undefined &&
      this.getTypeAvis() !== undefined) || this.isUpdate;
  }

  getSelectedAvisReference(ref) {
    this.canNavigateInStepperService.isAvisParentSelected = true;
    const selectedRef = ref.value;
    this.avisRefSelected = true;
    this.avisService.getAvisByReference(selectedRef).subscribe(avis => {
      //Lorsque qu'un SHAL est choisi dans les diffuseurs un deuxieme avis est créé pour ces distributeurs
      this.canNavigateInStepperService.avisIdParent = avis.avisId;
      if(avis.refAvisConnexe){
       this.avisService.getAvisByReference(selectedRef).subscribe(avisConnexe => {
         this.prepareDataWithParentAvis(avis);
       });
     }else{
      this.prepareDataWithParentAvis(avis);
     }
    });
  }

  private prepareDataWithParentAvis(parentAvis){
    this.canNavigateInStepperService.setReferenceParent(parentAvis);
    this.canNavigateInStepperService.diffReference.emit(parentAvis.flux);
    this.canNavigateInStepperService.selectedDiffuseurInitial = parentAvis.flux;
    if (!this.canNavigateInStepperService.currentFormulaire.includes('E_FORM')) {
      this.currentJson.next(parentAvis.reference);
    }
  }

  public isFieldDisabled() {
    return !(this.getTypeOrganisme() !== undefined) || this.isUpdate;
  }

  isReliable() {
    return this.canNavigateInStepperService.linkableNotices.length > 0 || this.canNavigateInStepperService.getReferenceParent();
  }

  isRelie() {
    return this.canNavigateInStepperService.getReferenceParent();
  }

  // get value from form
  private getTypeOrganisme(): string {
    return this.formExtractorService.getMapControlsIdWithoutStepAndValue(this.form).get('typeOrganisme');
  }

  private getMontantMarche(): string {
    return this.formExtractorService.getMapControlsIdWithoutStepAndValue(this.form).get('montantMarche');
  }

  private getTypeMarche(): string {
    return this.formExtractorService.getMapControlsIdWithoutStepAndValue(this.form).get('typeMarche');
  }

  private getTypeAvis(): string {
    return this.formExtractorService.getMapControlsIdWithoutStepAndValue(this.form).get('typeAvis');
  }
}
